import { render, staticRenderFns } from "./datasubject-boxes.vue?vue&type=template&id=1b4f133b&scoped=true"
import script from "./datasubject-boxes.vue?vue&type=script&lang=js"
export * from "./datasubject-boxes.vue?vue&type=script&lang=js"
import style0 from "./datasubject-boxes.vue?vue&type=style&index=0&id=1b4f133b&prod&lang=scss&scoped=true"
import style1 from "./datasubject-boxes.vue?vue&type=style&index=1&id=1b4f133b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f133b",
  null
  
)

export default component.exports